import { createApp } from 'vue'

import '../shared/base.css'
import App from './App.vue'

createApp(App).mount('#app')
